import { homeRoute, timeTrackerBeforeEnter } from './time-tracker-guards';

const DefaultContainer = () => import('@/containers/DefaultContainer');
const TimeTrackerShell = () => import('@/modules/time_tracker/TimeTrackerShell.vue');

const DashboardView = () => import('@/modules/time_tracker/views/DashboardView.vue');
const EmployeesView = () => import('@/modules/time_tracker/views/EmployeesView.vue');
const EmployeeDetailView = () => import('@/modules/time_tracker/views/EmployeeDetailView.vue');
const SelfServeOnboardingView = () => import('@/modules/time_tracker/views/SelfServeOnboardingView.vue');
const SelfServeZohoSignedCallback = () => import('@/modules/time_tracker/views/SelfServeZohoSignedCallback.vue');
const TimesheetsView = () => import('@/modules/time_tracker/views/TimesheetsView.vue');
const BonusesView = () => import('@/modules/time_tracker/views/BonusesView.vue');
const BonusSettingsView = () => import('@/modules/time_tracker/views/BonusSettingsView.vue');
const BonusPlannerView = () => import('@/modules/time_tracker/views/BonusPlannerView.vue');
const PayrollView = () => import('@/modules/time_tracker/views/PayrollView.vue');
const RolesView = () => import('@/modules/time_tracker/views/RolesView.vue');
const OfficeSettingsView = () => import('@/modules/time_tracker/views/OfficeSettingsView.vue');
const MyTimesheetView = () => import('@/modules/time_tracker/views/MyTimesheetView.vue');
const MyPayView = () => import('@/modules/time_tracker/views/MyPayView.vue');
const MyBonusesView = () => import('@/modules/time_tracker/views/MyBonusesView.vue');
const AccountSettingsView = () => import('@/modules/time_tracker/views/AccountSettingsView.vue');
const NotFoundView = () => import('@/modules/time_tracker/views/NotFoundView.vue');
const GuideView = () => import('@/modules/time_tracker/views/GuideView.vue');

const ttGuard = { beforeEnter: timeTrackerBeforeEnter };

var routes = [
  {
    path: '/onboarding/:token/zoho-signed',
    name: 'tt-self-serve-zoho-signed',
    component: SelfServeZohoSignedCallback,
    meta: {
      requiresAuth: false,
      checkPermission: false,
    },
  },
  {
    path: '/onboarding/:token',
    name: 'tt-self-serve-onboarding',
    component: SelfServeOnboardingView,
    meta: {
      requiresAuth: false,
      checkPermission: false,
    },
  },
  {
    path: '/time-tracker',
    redirect: () => homeRoute(),
    component: DefaultContainer,
    children: [
      {
        path: '/time-tracker',
        component: TimeTrackerShell,
        meta: { requiresAuth: true },
        children: [
          {
            path: 'dashboard',
            name: 'tt-dashboard',
            component: DashboardView,
            meta: { requiresAuth: true, permission: 'view_all_employees' },
            ...ttGuard,
          },
          {
            path: 'employees',
            name: 'tt-employees',
            component: EmployeesView,
            meta: { requiresAuth: true, permission: 'view_all_employees' },
            ...ttGuard,
          },
          {
            path: 'employees/:id',
            name: 'tt-employee-detail',
            component: EmployeeDetailView,
            meta: { requiresAuth: true, permission: 'view_all_employees' },
            ...ttGuard,
          },
          {
            path: 'timesheets',
            name: 'tt-timesheets',
            component: TimesheetsView,
            meta: { requiresAuth: true, permission: 'view_all_employees' },
            ...ttGuard,
          },
          {
            path: 'bonuses',
            name: 'tt-bonuses',
            component: BonusesView,
            meta: { requiresAuth: true, permission: 'manage_bonuses' },
            ...ttGuard,
          },
          {
            path: 'bonuses/settings',
            name: 'tt-bonus-settings',
            component: BonusSettingsView,
            meta: { requiresAuth: true, permission: 'manage_bonuses' },
            ...ttGuard,
          },
          {
            path: 'bonuses/planner',
            name: 'tt-bonus-planner',
            component: BonusPlannerView,
            meta: { requiresAuth: true, permission: 'manage_bonuses' },
            ...ttGuard,
          },
          {
            path: 'payroll',
            name: 'tt-payroll',
            component: PayrollView,
            meta: { requiresAuth: true, permission: 'view_payroll' },
            ...ttGuard,
          },
          {
            path: 'roles',
            name: 'tt-roles',
            component: RolesView,
            meta: { requiresAuth: true, requiresOwner: true },
            ...ttGuard,
          },
          {
            path: 'settings',
            name: 'tt-settings',
            component: OfficeSettingsView,
            meta: { requiresAuth: true, requiresOwner: true },
            ...ttGuard,
          },
          {
            path: 'me/timesheet',
            name: 'tt-my-timesheet',
            component: MyTimesheetView,
            meta: { requiresAuth: true, requiresEmployee: true },
            ...ttGuard,
          },
          {
            path: 'me/pay',
            name: 'tt-my-pay',
            component: MyPayView,
            meta: { requiresAuth: true, requiresEmployee: true },
            ...ttGuard,
          },
          {
            path: 'me/bonuses',
            name: 'tt-my-bonuses',
            component: MyBonusesView,
            meta: { requiresAuth: true, requiresEmployee: true },
            ...ttGuard,
          },
          {
            path: 'account',
            name: 'tt-account',
            component: AccountSettingsView,
            meta: { requiresAuth: true },
            ...ttGuard,
          },
          {
            path: 'guide',
            name: 'tt-guide',
            component: GuideView,
            meta: { requiresAuth: true },
            ...ttGuard,
          },
          {
            path: ':pathMatch(.*)*',
            name: 'tt-not-found',
            component: NotFoundView,
          },
        ],
      },
    ],
  },
];

export default routes;
